import { registerPlugin } from '@capacitor/core';

const Keychain = registerPlugin('Keychain');

const isNative = () => {
  return window.Capacitor && window.Capacitor.isNativePlatform();
};

let _tokenCache = null;

export const keychainService = {
  async init() {
    if (!isNative()) {
      _tokenCache = localStorage.getItem('session_token');
      return;
    }
    for (let i = 0; i < 5; i++) {
      try {
        const result = await Keychain.getItem({ key: 'session_token' });
        const value = result.value ?? null;
        if (value) {
          _tokenCache = value;
          console.log('[Keychain] init() attempt ' + (i + 1) + ': token found');
          return;
        }
        // Null could be a legitimate "no token" OR a bridge race -
        // retry a few times before accepting null as the final answer.
        console.warn('[Keychain] init() attempt ' + (i + 1) + ': returned null, retrying...');
        await new Promise(r => setTimeout(r, 200));
      } catch (e) {
        console.warn('[Keychain] init() attempt ' + (i + 1) + ' failed:', e);
        await new Promise(r => setTimeout(r, 200));
      }
    }
    // After all retries: fall back to localStorage as last resort.
    // This handles users mid-migration whose Keychain write failed silently
    // but who still have a valid legacy token sitting in localStorage.
    const legacy = localStorage.getItem('session_token');
    if (legacy) {
      console.warn('[Keychain] init() exhausted, using localStorage fallback');
      _tokenCache = legacy;
    } else {
      _tokenCache = null;
      console.error('[Keychain] init() failed after 5 attempts, no fallback available');
    }
  },

  getCached() {
    return _tokenCache;
  },

  async setItem(key, value) {
    if (key === 'session_token') _tokenCache = value;
    if (isNative()) {
      await Keychain.setItem({ key, value });
    } else {
      localStorage.setItem(key, value);
    }
  },

  async getItem(key) {
    if (isNative()) {
      const result = await Keychain.getItem({ key });
      return result.value ?? null;
    } else {
      return localStorage.getItem(key);
    }
  },

  async removeItem(key) {
    if (key === 'session_token') _tokenCache = null;
    if (isNative()) {
      await Keychain.removeItem({ key });
    } else {
      localStorage.removeItem(key);
    }
  }
};
